{
  "Accessibility Menu": "Меню за достъпност",
  "Reset settings": "Нулиране на настройките",
  "Close": "Затвори",
  "Content Adjustments": "Настройки на съдържанието",
  "Adjust Font Size": "Настройка на размера на шрифта",
  "Highlight Title": "Открояване на заглавието",
  "Highlight Links": "Открояване на връзките",
  "Readable Font": "Четим шрифт",
  "Color Adjustments": "Настройки на цветовете",
  "Dark Contrast": "Тъмен контраст",
  "Light Contrast": "Светъл контраст",
  "High Contrast": "Висок контраст",
  "High Saturation": "Висока наситеност",
  "Low Saturation": "Ниска наситеност",
  "Monochrome": "Монохромен",
  "Contrast": "Контраст",
  "Invert Colors": "Обърни цветовете",
  "Tools": "Инструменти",
  "Reading Guide": "Ръководство за четене",
  "Stop Animations": "Спри анимациите",
  "Big Cursor": "Голям курсор",
  "Increase Font Size": "Увеличи размера на шрифта",
  "Decrease Font Size": "Намали размера на шрифта",
  "Letter Spacing": "Разстояние между буквите",
  "Line Height": "Височина на реда",
  "Font Weight": "Дебелина на шрифта",
  "Dyslexia Font": "Шрифт за дислексия",
  "Language": "Език",
  "Open Accessibility Menu": "Отвори меню за достъпност",
  "Widget Settings": "Настройки на уиджета",
  "Widget Position": "Позиция на уиджета",
  "Top Left": "Горе вляво",
  "Top Center": "Горе в центъра",
  "Top Right": "Горе вдясно",
  "Center Left": "В центъра вляво",
  "Center Right": "В центъра вдясно",
  "Bottom Left": "Долу вляво",
  "Bottom Center": "Долу в центъра",
  "Bottom Right": "Долу вдясно",
  "Screen Reader": "Четец на екрана",
  "Voice Navigation": "Гласова навигация",
  "Custom Color": "Персонален цвят",
  "Change the site's colors": "Промени цветовете на сайта",
  "Backgrounds": "Фонове",
  "Headings": "Заглавия",
  "Contents": "Съдържание",
  "Reset colors": "Нулирай цветовете",
  "Image Desaturation": "Десатурация на изображението",
  "Search languages": "Търсене на езици",
  "No languages found": "Няма намерени езици",
  "Accessibility Profiles": "Профили за достъпност",
  "Motor Impaired": "Двигателни затруднения",
  "Big cursor, voice navigation, and no animations.": "Голям курсор, гласова навигация и без анимации.",
  "Blind": "Сляпо",
  "Screen reader helpers with higher contrast.": "Помощници за екранен четец с по-висок контраст.",
  "Color Blind": "Далтонизъм",
  "High contrast palette with desaturated media.": "Палитра с висок контраст и десатурирани медии.",
  "Dyslexia": "Дислексия",
  "Friendly font, extra spacing, stronger weight.": "Удобен шрифт, допълнително разстояние и по-силен акцент.",
  "Low vision": "Слабо зрение",
  "Dark contrast and 130% magnification.": "Тъмен контраст и увеличение 130%.",
  "Cognitive & Learning": "Когнитивно и обучително",
  "Highlights key sections and enables voice help.": "Акцентира важните секции и активира гласова помощ.",
  "Seizure & Epileptic": "Припадъци и епилепсия",
  "Stops animations and desaturates imagery.": "Спира анимациите и десатурира изображенията.",
  "ADHD": "СДВХ",
  "Reading guide, highlighted links, calmer palette.": "Водач за четене, подчертани връзки и по-спокойна палитра.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
